import { handleErrorException, loading, success } from 'State/actions';
import { TitleEnum } from 'Common/Constants/Enumeration/CommonEnum';

import * as types from './types';

export const printReport = input => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.TRANSACTION_HISTORY_REPORT_PRINT_LOADING, true));
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'TransactionHistoryReports/GetTxnHistoryPrint',
        input
      );
      const data = response.data.Data.Data;
      if (data) {
        dispatch({
          type: types.TRANSACTION_HISTORY_REPORT,
          payload: data,
        });
      } else {
        dispatch({
          type: types.TRANSACTION_HISTORY_REPORT_EMPTY_RESPONSE,
        });
      }
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message: 'An error occurred fetching Report. Please try again.',
      };
      dispatch(
        handleErrorException(
          ex,
          types.TRANSACTION_HISTORY_REPORT_PRINT_LOADING_ERROR,
          defaultError
        )
      );
    } finally {
      dispatch(loading(types.TRANSACTION_HISTORY_REPORT_PRINT_LOADING, false));
    }
  };
};

export const resetPrintResponse = () => {
  return dispatch => {
    dispatch({
      type: types.RESET_TRANSACTION_HISTORY_PRINT_RESPONSE,
    });
  };
};

export const getTxnItems = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(
      loading(types.TRANSACTION_HISTORY_REPORT_DROPDOWN_ITEMS_LOADING, true)
    );
    try {
      const response = await MPWWebApi.getGeneric(
        'TransactionHistoryReports/GetTxnItems'
      );
      dispatch(
        success(
          types.TRANSACTION_HISTORY_REPORT_DROPDOWN_ITEMS,
          response.data.Data.Data
        )
      );
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while fetching dropdown Items. Please try again.',
      };
      dispatch(
        handleErrorException(
          ex,
          types.TRANSACTION_HISTORY_REPORT_DROPDOWN_ITEMS_LOADING_ERROR,
          defaultError
        )
      );
    } finally {
      dispatch(
        loading(types.TRANSACTION_HISTORY_REPORT_DROPDOWN_ITEMS_LOADING, false)
      );
    }
  };
};

export const getSites = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.TRANSACTION_HISTORY_REPORT_SITES_LOADING, true));
    try {
      const response = await MPWWebApi.getGeneric('Sitemaster');
      dispatch(
        success(types.TRANSACTION_HISTORY_REPORT_SITES, response.data.Data)
      );
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message: 'An error occurred while fetching Sites. Please try again.',
      };
      dispatch(
        handleErrorException(
          ex,
          types.TRANSACTION_HISTORY_REPORT_SITES_LOADING_ERROR,
          defaultError
        )
      );
    } finally {
      dispatch(loading(types.TRANSACTION_HISTORY_REPORT_SITES_LOADING, false));
    }
  };
};

export const clearReportError = () => {
  return dispatch => {
    dispatch({
      type: types.CLEAR_REPORT_ERROR,
    });
  };
};



// WEBPACK FOOTER //
// ./src/pages/reports/inventory/transactionhistoryreport/state/actions.js